import { Routes } from '@angular/router';
import { roleGuard } from '../../../lib/guards/admin-role.guard';
import { permissionGuard } from '../../../lib/guards/permission.guard';
import { MENU_SCREEN_PRESET_CONFIG } from './base/menu-screen-preset-config';

export const menuScreenPresetRoutes: Routes = [
  {
    path: MENU_SCREEN_PRESET_CONFIG.routePath!,
    data: { title: 'Menu Screen Preset' },
    canActivate: [
      roleGuard('ADMIN_MASTER'),
      permissionGuard('HOME_SCREEN$READ'),
    ],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/menu-screen-preset-list-page/menu-screen-preset-list-page.component'
          ).then((m) => m.MenuScreenPresetListPageComponent),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/menu-screen-preset-detail-page/menu-screen-preset-detail-page.component'
              ).then((m) => m.MenuScreenPresetDetailPageComponent),
            data: { title: 'Menu Screen Preset Detail' },
          },
        ],
      },
    ],
  },
];
